import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { VariablesService, UtilService, EventsService, PaymentV2Service } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-sip-top-bank-listing',
  templateUrl: './payment-sip-top-bank-listing.component.html',
  styleUrls: ['./payment-sip-top-bank-listing.component.scss']
})
export class PaymentSipTopBankListingComponent implements OnInit, OnDestroy {

  @Input() config: IPaymentSipConfig;

  subs: Subscription[] = [];

  netBankForm: FormGroup;
  bankCode: FormControl;

  searchForm: FormGroup;
  searchText: FormControl;

  topBank = [
    { code: 'NB_SBI', name: 'SBI' },
    { code: 'NB_ICICI', name: 'ICICI' },
    { code: 'NB_KOTAK', name: 'KOTAK' },
    { code: 'NB_HDFC', name: 'HDFC' },
    { code: 'NB_AXIS', name: 'AXIS' },
    { code: 'NB_PNJSB', name: 'PNB' }
  ];

  bankList: any = [];
  selectedBank: any;
  unsupportedMethod = '';

  constructor(
    public variablesService: VariablesService,
    public utilService: UtilService,
    public paymentV2: PaymentV2Service,
    private eventsService: EventsService
  ) { }

  ngOnInit() {
    this.netBankForm = new FormGroup({
      banksName: this.bankCode = new FormControl('')
    });
    this.searchForm = new FormGroup({
      searchText: this.searchText = new FormControl(''),
    });
    this.subs.push(this.variablesService.lastOrderMode.subscribe({
      next: (res) => {
        if (this.config.paymentOptions && this.config.paymentOptions.options && res && res.value && res.mode === 'NB') {
          let bank = this.config.paymentOptions.options.RECURRINGBANK.find(o => o.params.bank_code === res.value);
          if (!bank) {
            bank = this.config.paymentOptions.options.RECURRINGBANK.find(o => o.code.toUpperCase().match('OTHER'));
          }
          this.selectTopBank(bank.code);
        }
      }
    }));
  }

  sort(arr) {
    if (!arr) { return []; }
    return arr.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
  }

  /**select the top bank from icon */
  selectTopBank(code) {
    this.bankCode.setValue(code);
    this.submitTopBank();
  }

  search(value) {
    if (!this.bankList.length) {
      this.bankList = this.config.paymentOptions.options.RECURRINGBANK;
    }
    this.config.paymentOptions.options.RECURRINGBANK = [];
    for (const item of this.bankList) {
      if ((item.name.toLowerCase().indexOf(value.toLowerCase()) > -1) || item.name.toLowerCase() === 'other') {
        this.config.paymentOptions.options.RECURRINGBANK.push(item);
      }
    }
  }
  resetSearch() {
    this.search('');
    this.searchForm.controls['searchText'].setValue('');
  }

  submitTopBank() {
    if (!this.bankCode.value || (this.selectedBank && this.selectedBank['code'] === this.bankCode.value)) { return; }

    for (const item of this.config.paymentOptions.options.RECURRINGBANK) {
      if (item.code === this.bankCode.value) {
        this.unsupportedMethod = '';
        if (!item.params.credit) { this.unsupportedMethod += (this.unsupportedMethod ? ' or ' : '') + 'Credit Card'; }
        if (!item.params.debit) { this.unsupportedMethod += (this.unsupportedMethod ? ' or ' : '') + 'Debit Card'; }
        if (!item.params.nb_emandate) { this.unsupportedMethod += (this.unsupportedMethod ? ' or ' : '') + 'Net Banking'; }
        if (!item.params.upi) { this.unsupportedMethod += (this.unsupportedMethod ? ' or ' : '') + 'UPI'; }

        this.config.selectEmandateBank = true;
        if (item.params.recommended === 'EMANDATE') { item.params.recommended = 'bank'; }

        this.config.recommendedTab = item.params.recommended = item.params.recommended.toLowerCase();

        this.config.optionTabs.map((tab) => {
          tab.recommended = false;
          tab.show = Object.keys(this.config.paymentOptions.options).includes(tab.mode);
          if (tab.show) {
            tab.show = item.params[tab.name] || false;
            if (tab.name === 'bank') { tab.show = item.params.nb_emandate; }
            if (tab.name === 'card') { tab.show = item.params.credit; }
            if (tab.tabs) {
              if (!item.params.debit_emandate || !Object.keys(this.config.paymentOptions.options).includes('CARD')) {
                tab.tabs = tab.tabs.filter(item1 => item1 !== 'CARD');
              } else {
                tab.tabs.push('CARD');
              }
            }
          }
        });

        // If recommended tab is not present in the options api then we need to change recomended tab
        const visibleTabs = this.config.optionTabs.filter(tab => tab.show);
        this.config.selectedTab = this.config.optionTabs.filter(tab => tab.name === this.config.recommendedTab && tab.show)[0];
        if (!this.config.selectedTab) { this.config.selectedTab = visibleTabs[0]; }
        this.config.recommendedTab = this.config.selectedTab.name;
        this.config.optionTabs.map((tab) => {
          if (tab.name === this.config.recommendedTab) { tab.recommended = true; }
        });

        this.selectedBank = item;
        this.paymentV2.paymentConfig.next(this.config);
        this.sendEvent();
        // setTimeout(() => {
        //   this.utilService.scrollIntoViewSmoothlyById('bank-dropdown');
        // }, 1);
      }
    }
  }

  sendEvent() {
    const systemEvent = {
      eventName: 'bank_name_added',
      info_1: this.selectedBank.name,
      info_3: 'impact',
      page_name: this.variablesService.pageName
    };
    this.eventsService.sendSystemEvent(systemEvent).subscribe(_ => _);
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
